import { hslaColors, themeColors } from '../colors';
import { gradients } from '../variables';

export const getColorAlpha = (
  color: keyof typeof hslaColors,
  alpha: number
) => {
  return `hsla(${hslaColors[color].h},${hslaColors[color].s}%,${hslaColors[color].l}%,${alpha})`;
};

export const getColorScale = (
  color: keyof typeof hslaColors,
  scaleType: string,
  scaleIncrement: number
): string => {
  const scaledValue = () => {
    if (scaleType === 'dark') {
      return hslaColors[color].l - hslaColors[color].l * scaleIncrement;
    } else if (scaleType === 'light') {
      return hslaColors[color].l + hslaColors[color].l * scaleIncrement;
    }
  };

  return `hsla(${hslaColors[color].h},${hslaColors[color].s}%,${Math.round(
    scaledValue()
  )}%,${hslaColors[color].a})`;
};

export const getColorValue = (color?: string): string | undefined => {
  if (color) {
    if (color in hslaColors || color in themeColors.light) {
      return `var(--lns-color-${color})`;
    }

    // Handle gradient colors
    if (color in gradients) {
      return `var(--lns-gradient-${color})`;
    }

    return color;
  }
};
